import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCalendar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.75 11.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V12a.75.75 0 0 1 .75-.75M12.75 12a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM16.25 11.25A.75.75 0 0 1 17 12v1.5a.75.75 0 0 1-1.5 0V12a.75.75 0 0 1 .75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.75 1.875a.75.75 0 0 1 .75.75V4h7V2.625a.75.75 0 0 1 1.5 0V4h1.25A2.75 2.75 0 0 1 21 6.75v12.5A2.75 2.75 0 0 1 18.25 22H5.75A2.75 2.75 0 0 1 3 19.25V6.75A2.75 2.75 0 0 1 5.75 4H7V2.625a.75.75 0 0 1 .75-.75M19.5 8.25v-1.5c0-.69-.56-1.25-1.25-1.25H5.75c-.69 0-1.25.56-1.25 1.25v1.5zm-15 1.5h15v9.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcCalendar = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCalendar));

export { IcCalendar as I };
